import React from 'react'
import { BuyP,BuyContainer, TopLine, BuyRow, Column1, Column2, Subtitle, ImgWrap, TextWrapper, BuySocial, TextWrapper2, TextWrapper4, ImgWrap2 } from './BuyElements'
import gif from '../../images/GIF.gif'
import './buy.css'
import Timer from '../Timer'
import insta from '../../images/insta.png'
import twi from '../../images/twitter.png'
import dc from '../../images/dc.png'
import StartM from '../StartM'
import { Link } from 'react-scroll'
import store from "../redux/store";
import { Provider } from "react-redux";

const Buy = () => {
    return (
        
        <BuyContainer id="Mint">
            <Provider store={store}>
            <TopLine>Mint</TopLine>
            
            <BuyRow imgStart={true}>
                        <ImgWrap2><img className="Buypic2" src={gif} /></ImgWrap2>
                
                        <Column1>
                        <TextWrapper>
                            <Subtitle darkText={false}>
                            Total Supply: 10,000 <br />
Minting Price: 0.04 eth + Gas Fee
                            </Subtitle>
                            <BuyP>*A maximum of 20 Dinos per transaction</BuyP>
                        </TextWrapper>
                        {/* <Timer /> */}
                        
                        <TextWrapper2>COMING SOON</TextWrapper2>
                        <TextWrapper>
                            <Subtitle darkText={false}>
                            Join our community to know more! 
                            </Subtitle>
                        </TextWrapper>
                        
                        <BuySocial>
                            <a target="_blank" href="https://www.instagram.com/the_dnms_nft/"><img src={insta} className="contacts" alt="insta"/></a>
                            <a target="_blank" href="https://twitter.com/TheDNMS_NFT/status/1440352189210263553"><img src={twi} className="contacts" alt="twitter"/></a>
                            <a target="_blank" href="https://discord.gg/nmbscCSGTr"><img src={dc} className="contacts" alt="dc"/></a>
                        </BuySocial>

                        {/* <StartM /> */}
                        <TextWrapper4 ><Link  to="Contact" smooth={true} duration={1000}>And Subscribe</Link></TextWrapper4>
                        </Column1>
                        <Column2>
                            <ImgWrap>
                                <img className="Buypic" src={gif} />
                            </ImgWrap>
                        </Column2>
                    </BuyRow>
                    </Provider>
        </BuyContainer>
    )
}

export default Buy
